import { h } from 'preact';
import { useNewStore, usePlayerContext } from '../../../common/hooks';
import { Delayed, withBreakPoints } from '../../hoc';
import SpinnerFranceTV from './spinner';

import { INTRO_TRANSITION_OUT, INTRO_WRAPPER_STYLES } from '../../../common/styles';
import { onFinishCreator } from '../../../common/utils/tools';

function Spinner() {
  const player = usePlayerContext();
  const { waiting, isIntro, width, height } = useNewStore('ui', player);
  if (!waiting && !isIntro) return null;

  return (
    <div style={{
      ...INTRO_WRAPPER_STYLES,
      width,
      height,
      ...(waiting || isIntro ? {} : INTRO_TRANSITION_OUT)
    }}
    >
      <Delayed
        isMounted={waiting}
        shouldDelay={isIntro}
        delay={2000}
        onFinish={onFinishCreator(player, isIntro)}
      >
        {(delayedState) => <SpinnerFranceTV {...delayedState} />}
      </Delayed>
    </div>
  );
}

export default withBreakPoints(Spinner);
